<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <CodeValidator :code="code" />
      </div>
    </div>
  </div>
</template>

<script>
import CodeValidator from "@/components/reward/CodeValidator.vue";

export default {
  name: "RewardView",
  components: {
    CodeValidator
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  mounted() {
    history.pushState({}, "", "/#/reward/");
  }
};
</script>
